import { FinancialPlanValuesResponse } from "../pages/application-coo-stage-d/types";

export const DUMMY_RESPONSE: FinancialPlanValuesResponse = {
  constant: {
    version_by: "hdb",
    valuation_limit: 100_000,
    total_payable: 200_000,
    owner_details: [
      { uinfin: "S123456A", name: "Owner 1", endorsed: false },
      { uinfin: "S123456B", name: "Owner 2", endorsed: false },
    ],
    cpf_details: [
      { uinfin: "S123456A", cpf_min: 10_000, cpf_max: 250_000 },
      { uinfin: "S123456B", cpf_min: 12_000, cpf_max: 22_000 },
    ],
    loan_detail: { loan_max: 100_000 },
    stamp_fee: { basic_amount: 10_000 },
    conveyancing_fee: { basic_amount: 200 },
    registration_fee: { basic_amount: 300 },
    hps_fees: [
      { uinfin: "S123456A", basic_amount: 500 },
      { uinfin: "S123456B", basic_amount: 400 },
    ],
    extra_fees: [{ name_of_fee: "Custom fee", basic_amount: 600 }],
  },
  hdb_input: {
    cpf_details: [
      { uinfin: "S123456A", cpf_val: 15_000 },
      { uinfin: "S123456B", cpf_val: 15_000 },
    ],
    loan_detail: { loan_val: 50_000, repayment_period: 10 },
    stamp_fee: { paid_by: "cash" },
    conveyancing_fee: { paid_by: "S123456A" },
    registration_fee: { paid_by: "S123456B" },
    hps_fees: [
      { uinfin: "S123456A", paid_by: "cash" },
      { uinfin: "S123456B", paid_by: "S123456B" },
    ],
    extra_fees: [{ name_of_fee: "Custom fee", paid_by: "cash" }],
  },
  others_input: {
    cpf_details: [
      { uinfin: "S123456A", cpf_val: 16_000 },
      { uinfin: "S123456B", cpf_val: 16_000 },
    ],
    loan_detail: { loan_val: 60_000, repayment_period: 11 },
    stamp_fee: { paid_by: "cash" },
    conveyancing_fee: { paid_by: "S123456A" },
    registration_fee: { paid_by: "S123456B" },
    hps_fees: [
      { uinfin: "S123456A", paid_by: "cash" },
      { uinfin: "S123456B", paid_by: "S123456B" },
    ],
    extra_fees: [{ name_of_fee: "Custom fee", paid_by: "cash" }],
  },
};
